import { render, staticRenderFns } from "./insurer-summary.vue?vue&type=template&id=6a154f04&scoped=true"
import script from "./insurer-summary.vue?vue&type=script&lang=js"
export * from "./insurer-summary.vue?vue&type=script&lang=js"
import style0 from "./insurer-summary.vue?vue&type=style&index=0&id=6a154f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a154f04",
  null
  
)

export default component.exports